/**
 * 渠道信息
 * @author lianghua.fu
 * @date 2020-10-14 11:52:23
 */
import assign from 'lodash/assign';

import {api} from './request'
import {log} from './debug'
import User from './user'

import storage from './storage'

const QD_CONFIG_INFO = 'QD_CONFIG_INFO'
const CACHE_TIME = 1000 * 60 * 30;

type QdInfo = {}

let defaultConfig = {
    isHideDownload: 1,
    h5CooInfo: '商务合作QQ: 1445098960',
    isAd: 1,
    isRoomPay: 0,
    ios_url: '',
    ckey: 'CK1323874108342',
    from: '',
    qrcode_img: '',
    timestamp: new Date().getTime()
}

let qdConfigInfo = null

const init = () => {
    let _qdInfo = storage.getItem(QD_CONFIG_INFO) as any;
    if (_qdInfo && Date.now() - _qdInfo.timestamp < CACHE_TIME) {
        qdConfigInfo = _qdInfo
    } else {
        let qd = User.getQdInfo().qd
        api.get(`channel/prop?_id=${qd}`)
            .then((res: any) => {
                let props: any = {}
                if (res.data) {
                    props = res.data.properties || {};
                    props.qrcode_img = res.data.qrcode_img;
                } else {
                    props.qrcode_img = '';
                }
                qdConfigInfo = assign({}, defaultConfig, props);
                storage.setItem(QD_CONFIG_INFO, qdConfigInfo);
            })
    }
}

const getConfig = () => {
    return qdConfigInfo
}

const channel = {
  init,
  getConfig
}

export default channel;

